<!-- Pricing -->
<section class="py-20 bg-white dark:bg-slate-800" id="tarifs">
  <div class="max-w-7xl mx-auto px-4">
    <div class="text-center mb-16 scroll-fade-in">
      <h2 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">
        Un tarif simple et transparent
      </h2>
      <p class="text-xl text-gray-600 dark:text-gray-400">
        Adapté aux marchands fixes 🏪 et itinérants 🚚 • Essai gratuit 1 mois •
        Sans CB • Annuel : 2 mois offerts
      </p>
      <div class="mt-6"><app-founder-banner /></div>
    </div>

    <div class="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
      <!-- Starter -->
      <div
        class="pricing-card bg-white dark:bg-slate-800 border-2 border-gray-200 dark:border-slate-700 rounded-2xl p-8 hover:border-purple-600 transition duration-300 scroll-fade-in"
      >
        <div
          class="text-sm font-semibold text-purple-600 uppercase tracking-wide mb-2"
        >
          Starter
        </div>
        <div class="mb-4">
          <span class="text-4xl font-bold text-gray-900 dark:text-white"
            >19.90€</span
          >
          <span class="text-gray-600 dark:text-gray-400">/mois</span>
        </div>
        <p class="text-gray-600 dark:text-gray-400 mb-6">
          Parfait pour débuter
        </p>
        <ul class="space-y-3 mb-8">
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >10 événements / mois (marchand itinérant)</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >Recommandations IA</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >Météo temps réel</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300">Export PDF</span>
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300">Support email</span>
          </li>
        </ul>
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-4 text-center">
          🏪 Boutique • 🚚 Food-truck • 🎪 Marché
        </p>
        <a
          href="#"
          class="block w-full bg-gray-900 text-white text-center py-3 rounded-lg font-bold hover:bg-gray-800 transition"
        >
          Essayer gratuitement
        </a>
      </div>

      <!-- Pro (Popular) -->
      <div
        class="pricing-card bg-gradient-to-br from-purple-600 to-purple-700 rounded-2xl p-8 relative transform scale-105 shadow-2xl scroll-fade-in"
      >
        <div
          class="absolute top-0 right-0 bg-yellow-400 text-gray-900 dark:text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg"
        >
          ⭐ POPULAIRE
        </div>
        <div
          class="text-sm font-semibold text-purple-200 uppercase tracking-wide mb-2"
        >
          Pro
        </div>
        <div class="mb-4">
          <span class="text-4xl font-bold text-white">29.90€</span>
          <span class="text-purple-200">/mois</span>
        </div>
        <p class="text-purple-100 mb-6">
          Pour les pros actifs (fixes ou itinérants)
        </p>
        <ul class="space-y-3 mb-8">
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-white font-medium"
              >Événements illimités (marchand itinérant)</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-white">Tout du Starter +</span>
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-white">Analytics avancés</span>
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-white">Notifications auto</span>
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-white">Support prioritaire</span>
          </li>
        </ul>
        <p class="text-xs text-purple-200 mb-4 text-center">
          Idéal pour activités fixes et itinérantes
        </p>

        <a
          href="#"
          class="block w-full bg-white dark:bg-slate-800 text-purple-600 text-center py-3 rounded-lg font-bold hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 transition"
        >
          Commencer maintenant
        </a>
      </div>

      <!-- Business -->
      <div
        class="pricing-card bg-white dark:bg-slate-800 border-2 border-gray-200 dark:border-slate-700 rounded-2xl p-8 hover:border-purple-600 transition duration-300 scroll-fade-in"
      >
        <div
          class="text-sm font-semibold text-purple-600 uppercase tracking-wide mb-2"
        >
          Business
        </div>
        <div class="mb-4">
          <span class="text-4xl font-bold text-gray-900 dark:text-white"
            >49.90€</span
          >
          <span class="text-gray-600 dark:text-gray-400">/mois</span>
        </div>
        <p class="text-gray-600 dark:text-gray-400 mb-6">
          Multi-stands & équipes
        </p>
        <ul class="space-y-3 mb-8">
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300">Tout du Pro +</span>
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >Jusqu'à 5 stands</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300">Gestion équipe</span>
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >Benchmarks secteur</span
            >
          </li>
          <li class="flex items-start gap-2">
            <svg
              class="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="text-gray-700 dark:text-gray-300"
              >Onboarding dédié</span
            >
          </li>
        </ul>
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-4 text-center">
          Réseaux • Multi-stands • Équipes
        </p>

        <a
          href="#"
          class="block w-full bg-gray-900 text-white text-center py-3 rounded-lg font-bold hover:bg-gray-800 transition"
        >
          Nous contacter
        </a>
      </div>
    </div>

    <div class="text-center mt-12 text-gray-600 dark:text-gray-400">
      <p class="mb-2">
        🔒 Paiement sécurisé • 💳 Annulation à tout moment • 📧 Support réactif
      </p>
    </div>
  </div>
</section>
